// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__264B_","addWidgetButton":"Header_addWidgetButton__1j3Y-","dashboardTabs":"Header_dashboardTabs__1SlnA","active":"Header_active__3CBHM"};